import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M 11.531 8.5 C 11.531 8.605 11.498 8.711 11.431 8.8 L 5.431 16.8 C 5.265 17.021 4.952 17.066 4.731 16.9 S 4.465 16.421 4.63 16.2 L 10.405 8.5 L 4.63 0.8 C 4.465 0.58 4.51 0.267 4.731 0.1 C 4.952 -0.065 5.265 -0.02 5.431 0.201 L 11.431 8.201 C 11.497 8.29 11.531 8.395 11.531 8.501 Z',
  ],
  height: 17,
  width: 16,
});
